export default __webpack_public_path__ + "static/nordax-bank-e41005f9a1f5673d4ea8b8e5fa3ee1e0.png";